import { render } from "./NotifyDialog.vue?vue&type=template&id=6d7a3d50"
import script from "./NotifyDialog.vue?vue&type=script&lang=js"
export * from "./NotifyDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__